<template>
  <div class="user-box">
    <div class="user-sidebar">
      <div class="user-sidebar-title">
        <img src="@/assets/icon_user_title.png">
        <span>欢迎参赛</span>
      </div>
      <div class="user-menu">
        <div class="user-li menu-activate">
          <img src="@/assets/icon_user_info_selected.png">
          <span>个人信息</span>
        </div>
        <div class="user-li" @click="goWork()">
          <img src="@/assets/icon_user_work_unselect.png">
          <span>作品管理</span>
        </div>
        <div class="user-li" @click="goCert()">
          <img src="@/assets/icon_user_cert_unselect.png">
          <span>证书查询</span>
        </div>
      </div>
    </div>
    <div class="user-content">
      <div class="user-avatar-box">
        <div class="user-avatar">
          <label for="def_input">
            <img :src="avatar || require('@/assets/default_av.png')" alt=" ">
          </label>
          <input type="file" accept="image/*" hidden id="def_input" @change="getFile">
        </div>
        <span>{{ realname }}</span>
      </div>
      <div class="user-form">
        <div class="user-form-item">
            <div class="item-required">*</div>
            <div class="item-label">真实姓名</div>
            <div class="item-input"><input type="text" placeholder="" autocomplete="new-userName" v-model="realname"></div>
        </div>
        <div class="user-form-item">
            <div class="item-required">*</div>
            <div class="item-label">性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别</div>
            <div class="item-input">
              <el-select v-model="sexType" filterable remote placeholder="">
                <el-option
                    v-for="item in arrSexType"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
        </div>
        <div class="user-form-item">
            <div class="item-required">*</div>
            <div class="item-label">手机号码</div>
            <div class="item-input"><input type="text" placeholder="" autocomplete="new-phone" v-model="phone"></div>
        </div>
        <div class="user-form-item">
            <div class="item-required">*</div>
            <div class="item-label">邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱</div>
            <div class="item-input"><input type="text" placeholder="" autocomplete="new-email" v-model="email"></div>
        </div>
        <div class="user-form-item">
            <div class="item-required">*</div>
            <div class="item-label">国&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;籍</div>
            <div class="item-input"><input type="text" placeholder="" autocomplete="new-country" v-model="country"></div>
        </div>
        <div class="user-form-item">
            <div class="item-required">*</div>
            <div class="item-label">身&nbsp;&nbsp;份&nbsp;&nbsp;证</div>
            <div class="item-input"><input type="text" placeholder="" autocomplete="new-idcard" v-model="idcard"></div>
        </div>
        <div class="user-form-item">
            <div class="item-required">*</div>
            <div class="item-label">院&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;校</div>
            <div class="item-input">
              <el-select v-model="school" filterable remote placeholder="" :remote-method="searchSchool">
                  <el-option
                      v-for="item in arrSchool"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
            </div>
        </div>
        <div class="user-form-item">
            <div class="item-required">*</div>
            <div class="item-label">学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;院</div>
            <div class="item-input"><input type="text" placeholder="" autocomplete="new-college" v-model="college"></div>
        </div>
        <div class="user-form-item">
            <div class="item-required"></div>
            <div class="item-label">系&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;部</div>
            <div class="item-input"><input type="text" placeholder="" autocomplete="new-department" v-model="department"></div>
        </div>
        <div class="user-form-item">
            <div class="item-required"></div>
            <div class="item-label">专&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业</div>
            <div class="item-input"><input type="text" placeholder="" autocomplete="new-major" v-model="major"></div>
        </div>
        <div class="user-form-item">
            <div class="item-required">*</div>
            <div class="item-label">学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历</div>
            <div class="item-input">
              <el-select v-model="educational" filterable remote placeholder="">
                <el-option
                    v-for="item in arrEducational"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </div>
        </div>
        <div class="user-form-item">
            <div class="item-required"></div>
            <div class="item-label">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称</div>
            <div class="item-input"><input type="text" placeholder="" autocomplete="new-qualifications" v-model="qualifications"></div>
        </div>
        <div class="user-form-item user-form-passwd">
            <div class="item-required"></div>
            <div class="item-label">修改密码</div>
            <div class="item-input"><input type="text" placeholder="" autocomplete="new-password" v-model="password"></div>
        </div>
        <div class="btn-save" @click="submitLogin()">保&nbsp;&nbsp;&nbsp;存</div>
      </div>
    </div>
  </div>
</template>

<script>
import {Warning} from "@/plugins/warning";
import {accountProfile,getUserInfo,getSearchSchoolFilter,updateAv} from "@/request/api";
import {mapGetters} from "vuex";
import $ from "jquery";
import OSS from "ali-oss";
export default {
  name: "accountManage",
  components:{
  },
  data() {
    return {
      avatar: '',
      username: '', //用户名
      realname: '',
      sexType: 1,
      phone:'',
      email:'',
      country:'中国',
      idcard:'',
      school:'',
      college:'',
      department:'',
      major:'',
      educational:'',
      qualifications:'',
      password: '',
      arrSchool:[],
      arrSexType:[{"id":1,"name":"男"},{"id":2,"name":"女"}],
      arrEducational:["硕士及以上","本科","大专","高中及以下"]
    }
  },
  computed: {
    ...mapGetters('infoModule',['getUserInfoObj']),
  },
  created() {
    //this.email = this.getUserInfoObj.email;
    this.getUserInfo();
    //this.getUserInfo();
  },
  mounted() {
  },
  methods: {
    toBack(){
      this.$router.go(-1)
    },
    radioSexFn(sexType){
      this.sexType = sexType
    },
    getUserInfo(){
      getUserInfo({}).then((res)=>{
        if(res.data.gender != 0){
          this.sexType = res.data.gender;
        }
        this.realname = res.data.realname;
        this.avatar = res.data.avatar;
        this.username = res.data.username;
        this.phone = res.data.phone;
        this.email = res.data.email;
        this.country = res.data.country;
        this.idcard = res.data.idcard;
        this.school = res.data.school;
        this.college = res.data.college;
        this.department = res.data.department;
        this.major = res.data.major;
        this.educational = res.data.educational;
        this.qualifications = res.data.qualifications;
        
        if(this.school != ''){
          this.searchSchool(this.school);
        }

        localStorage.setItem('realname', res.data.realname);

      })
    },
    submitLogin(){
      const {realname,phone,email,sexType,country,idcard,school,college,department,major,educational,qualifications,password} = this;
      const requestData = {
        realname:realname,
        phone:phone,
        email:email,
        country:country,
        idcard:idcard,
        school:school,
        college:college,
        department:department,
        major:major,
        educational:educational,
        qualifications:qualifications,
        password:password,
        gender: sexType
      }
      accountProfile(requestData).then((res)=>{
        Warning.success(res.msg)
        //this.initComponentsData()
        // this.$store.commit('infoModule/updateToken',res.data.token);
        // Warning.success('登录成功，即将跳转首页')
        // setTimeout(()=>{
        //   this.$router.push({name:'About'})
        // },2500)
      })
    },
    searchSchool(key){
      const requestData = {
        school: key,
      };
      getSearchSchoolFilter(requestData).then((res)=>{
        this.arrSchool = res.data;
      })
    },
    goWork(){
      this.$router.push({name:'userWorks'})
    },
    goCert(){
      this.$router.push({name:'userCertificate'})
    },
    getFile(e){
      const that = this;
      const file = e.target.value;
      let filename=file.replace(/.*(\/|\\)/, "");
      let fileExt=(/[.]/.exec(filename)) ? /[^.]+$/.exec(filename.toLowerCase()) : '';
      let storage = JSON.parse(window.localStorage.getItem('STORAGE'));
      $.ajax({
        url: process.env.VUE_APP_SERVER_URL+'/works/uploads/index',
        data:{
          suffix:fileExt[0],
          path:"avatar"
        },
        headers:{
          Authorization:storage.infoModule.token
        },
        async: true,
        global: false,
        type: 'POST',
        dataType: 'json',
        timeout:1000*7,
        success: function(data) {
          if (data.status === 200) {
            const client = new OSS({
              region: data.result.data.region,
              accessKeyId: data.result.data.access_key_id,
              accessKeySecret: data.result.data.access_key_secret,
              stsToken: data.result.data.security_token,
              bucket: data.result.data.bucket,
            });

            client.multipartUpload(data.result.data.key, e.target.files[0], {
              // 设置上传回调。
              progress:(p) => {
                if(p>=1){
                  updateAv({avatar:data.result.data.url}).then(()=>{
                    that.$store.dispatch('infoModule/getUserInfo')
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000)
                  })
                }
              }
            });
          }else {
            Warning.open(data.msg);
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.user-box{
  width: 1280px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  padding-bottom: 200px;
  background: #F6F6F6;
  display: flex;
  .user-sidebar{
    width: 320px;
    height: 560px;
    background: #fff;
    //box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    .user-sidebar-title{
      width: 260px;
      height: 56px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 50px;
      img{
        width: 56px;
        height: 56px;
        float: left;
      }
      span{
        font-size: 24px;
        font-weight: 500 ;
        color: #FF3B30;
        height: 56px;
        line-height: 56px;
        float: left;
        margin-left: 20px;
      }
    }
    .user-menu{
      width: 260px;
      height: 340px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 50px;
      .user-li{
        float: left;
        width: 260px;
        height: 65px;
        margin-bottom: 30px;
        background-color: #FFF;
        cursor: pointer;
        img{
          width: 32px;
          height: 32px;
          float: left;
          margin-left: 25px;
          margin-top: 16px
        }
        span{
          font-size: 20px;
          font-weight: 400;
          color: #696969;
          height: 65px;
          line-height: 65px;
          float: left;
          margin-left: 20px;
        }
      }
      .menu-activate{
        background-color: #FF3B30;
        span{
          color: #FFF;
        }
      }
    }
  }
  .user-content{
    width: 930px;
    height: 870px;
    margin-left: 35px;
    background: #fff;
    //box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    .user-avatar-box{
      width: 95px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 30px;
      .user-avatar{
        height: 95px;
        width: 95px;
        background: url(~@/assets/user_avatar_bg.png);
        background-size: cover;
        img{
          margin-top: 10px;
          margin-left: 10px;
          height: 72px;
          width: 72px;
          border-radius: 50%;
          overflow: hidden;
          cursor: pointer;
        }
      }
      span{
        font-size: 20px;
        font-weight: 400;
        color: #3F3F3F;
        height: 29px;
        line-height: 29px;
        text-align: center;
        display: block;
        margin-top: 10px;
      }
    }
    .user-form{
      width: 590px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 45px;
      .user-form-item{
        float: left;
        width: 280px;
        height: 33px;
        font-size: 14px;
        margin-right: 15px;
        margin-bottom: 30px;
        .item-required{
          float: left;
          color: #FF3B30;
          height: 33px;
          line-height: 33px;
          width: 10px;
        }
        .item-label{
          float: left;
          height: 33px;
          width: 70px;
          line-height: 33px;
        }
        .item-input{
          float: left;
          height: 33px;
          width: 200px;
          border-radius: 4px;
          border: 1px solid #ccc;
          & > input {
            width: 100%;
            height: 33px;
            line-height: 33px;
            font-size: 12px;
            background: transparent;
            padding-left: 10px;
            padding-right: 10px;
            border: none;
            outline: none;
            &:-webkit-autofill,
            &:-webkit-autofill:hover,
            &:-webkit-autofill:focus,
            &:-webkit-autofill:active {
              -webkit-box-shadow: 0 0 0 30px transparent inset !important;
              box-shadow: 0 0 0 30px transparent inset !important;
              background-color: transparent !important;
              background-image: none !important;
              transition: background-color 5000s ease-in-out 0s;
            }
          }
        }
      }
      .user-form-passwd{
        width: 590px;
        .item-input{
          width: 495px;
        }
      }
      .btn-save{
        float: left;
        width: 130px;
        height: 33px;
        margin-left: 80px;
        margin-top: 30px;
        line-height: 33px;
        font-size: 12px;
        text-align: center;
        color: #FFFFFF;
        cursor: pointer;
        border-radius: 4px;
        background: #FF3B30;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>
<style>
.el-input__inner{
  height: 31px;
  line-height: 31px;
  border: none;
}
.el-input__suffix{
  height: 12px;
  width: 12px;
  margin-top: 10px;
  margin-right: 10px;
  background: url(~@/assets/icon_select_arrow.png) no-repeat;
  background-size: cover;
}
</style>